/* unplugin-vue-components disabled */module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"text":"Мы используем cookie, чтобы сделать наш сайт максимально удобным для вас","buttonLabel":{"agreement":"Подробнее","accept":"Принять"}}}')
  delete Component.options._Ctor
}
